import styled from 'styled-components';
import { getMediaQueriesMFByTheme } from './utils';

const AMIGO_HEADER_HEIGHT = '102px';
const VODAFONE_MOBILE_HEADER_HEIGHT = '60px';
const VODAFONE_TABLET_HEADER_HEIGHT = '68px';
const VODAFONE_HEADER_HEIGHT_DESKTOP = '116px';

const HEADER_MENU_EXTRA_BREAKPOINT_VODAFONE = 1155;

const MainContainer = styled.div`
    flex: 1;
    background-color: #f2f2f2;
`;

const ContentContainer = styled.div<{ isAmigo: boolean }>`
    padding-top: 0px;
    display: flex;
    flex-direction: column;
    flex: 1;

    min-height: 100vh;

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).mobile} {
        padding-top: ${({ isAmigo }) => (isAmigo ? AMIGO_HEADER_HEIGHT : VODAFONE_MOBILE_HEADER_HEIGHT)};
    }

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).tablet} {
        padding-top: ${({ isAmigo }) => (isAmigo ? AMIGO_HEADER_HEIGHT : VODAFONE_TABLET_HEADER_HEIGHT)};
    }

    ${({ isAmigo }) =>
        !isAmigo &&
        `
        @media (min-width: ${HEADER_MENU_EXTRA_BREAKPOINT_VODAFONE}px) {
            padding-top: 0;
        }
    `}

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).superDesktop} {
        ${({ isAmigo }) =>
            !isAmigo &&
            `
            min-height: calc(100vh - ${VODAFONE_HEADER_HEIGHT_DESKTOP});
        `}
    }
`;

const InnerContainer = styled.div<{ isMfeRunning: boolean }>`
    max-width: 1180px;
    width: 100%;
    margin: 0 auto;
    padding: 24px;
    padding-top: ${({ isMfeRunning }) => (isMfeRunning ? '0px' : '24px')};
    display: flex;
    flex-direction: ${({ isMfeRunning }) => (isMfeRunning ? 'row' : 'column')};
    flex: 1;

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).superDesktop} {
        ${({ isMfeRunning }) =>
            !isMfeRunning
                ? `
        justify-content: center;
    `
                : ''}
    }
`;

const UserInfo = styled.div`
    text-align: center;
    margin-bottom: 16px;
`;

const WelcomeMessage = styled.p`
    font-size: 24px;
    font-family: ${({ theme }) => theme.fontFamily};
    text-align: center;
    padding: 0 0 8px 0;
`;

const Email = styled.p`
    font-size: 16px;
    font-family: ${({ theme }) => theme.fontFamily};
    text-align: center;
`;

const MenuContainer = styled.div<Partial<{ $left: number; $right: number; $top: number; $bottom: number }>>`
    position: absolute;
    width: 200px;
    top: ${({ $top }) => `${$top}px`};
    bottom: ${({ $bottom }) => `${$bottom}px`};
    left: ${({ $left }) => `${$left}px`};
    right: ${({ $right }) => `${$right}px`};
    z-index: 100000;
`;

export { MainContainer, ContentContainer, InnerContainer, UserInfo, WelcomeMessage, Email, MenuContainer };
